<template>
  <div class="telfdlay between">
    <div class="findlay">
      <div>
        <div class="title between">
          <div class="row_title">按专长查找合肥律师</div>
          <!-- <div class="specilist flex_end">
            <div
              class="specitem"
              v-for="(item, index) in specilist"
              :key="index"
              :class="{ active: index == speciactive }"
              @click="speciactive = index"
            >
              {{ item }}
            </div>
          </div> -->
        </div>
        <div class="content flex_start wrap">
          <div class="item" v-for="item in 17" :key="item">拆迁安置</div>
        </div>
      </div>
      <div class="margigTop30">
        <div class="row_title">合肥周边律师</div>
        <div class="content flex_start wrap">
          <div class="item" v-for="item in 17" :key="item">巢湖市</div>
        </div>
      </div>
    </div>
    <div class="lately">
      <sub-title text="最近服务记录" />
      <div class="tel_timeline">
        <lat-ser-timeline />
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
import latSerTimeline from "../components/lat_ser_timeline";
export default {
  components: { subTitle, latSerTimeline },
  data: () => ({
    speciactive: 0,
    specilist: ["民事", "经济", "刑事", "公司", "涉外", "其他"],
  }),

  mounted() {
    let a = function () {
      return {};
    };
    console.log("this", this);
  },
};
</script>

<style lang="scss" scope>
.telfdlay {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  .findlay {
    width: 816px;
    .row_title {
      font-size: 24px;
      color: #333333;
    }
    .title {
      .specilist {
        .specitem {
          width: 64px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          cursor: pointer;
          color: #666666;
          background: #eeeeee;
          margin-left: 12px;
        }
        .specitem.active {
          color: #fff;
          background: #0465ea;
        }
      }
    }
    .content {
      height: 168px;
      margin-top: 25px;
      padding: 33px 34px;
      color: #666;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(38, 38, 38, 0.08);
      font-size: 14px;
      line-height: 14px;
      .item {
        cursor: pointer;
        text-align: left;
        width: 16.6%;
        padding-left: 30px;
        margin-bottom: 28px;
        position: relative;
        &::before {
          content: "";
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: #dddddd;
          position: absolute;
          top: 50%;
          left: 15px;
          transform: translateY(-50%);
        }
        &:hover {
          color: #0465ea;
        }
      }
    }
    .margigTop30 {
      margin-top: 30px;
    }
  }
  .lately {
    width: 354px;
    padding: 18px 15px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(38, 38, 38, 0.08);
    .tel_timeline {
      margin-top: 30px;
    }
  }
}
</style>